import "./Gallery.module.css";
import HeaderPrincipale from "@/reusable_sections/Header";
import IdeeESoluzioni from "./sections/IdeeESoluzioni";
import CartContent from "./sections/CartContent";
import Footer from "../Home/sections/Footer";
export default function GalleryPage() {
  return <div>
      <HeaderPrincipale />
      <IdeeESoluzioni />
      <CartContent />
      <Footer />
    </div>;
}